type ScrollToTopBehavior = ScrollBehavior;

export const scrollToTop = (behavior: ScrollToTopBehavior = 'auto') => {
  window.scrollTo({ top: 0, left: 0, behavior });
};
